export default __webpack_public_path__ + "static/media/mission.ae29d86d.svg";